module.exports = __webpack_public_path__ + "static/media/2.954e90ea.jpg";